export const Bio = {
    name: "Abhay Pratap Singh",
    roles: [
      "MERN Stack Developer",
      "Programmer",
      "Content Writer"
    ],
    description: "To kickstart my career as a software developer, utilizing my strong programming skills and eager to learn from experienced industry professionals. My goal is to contribute effectively to projects, innovate, and grow as a versatile developer while adding value to the organization",
    github: "https://github.com/abhay-01",
    resume: "https://drive.google.com/file/d/1GApkvJa7Mjx4bNUzdcsCD1zqYIbHRIBJ/view?usp=sharing",
    linkedin: "https://www.linkedin.com/in/abhay-pratap-singh01/",
    twitter: "https://x.com/Solo_Abhay",
    insta: "https://www.instagram.com/iamabhay.21/",
    facebook: "https://www.facebook.com/lbsnaa2025/",
};
  
export const skills = [
    {
      title: "Programming Languages",
      skills: [
        {
          name: "C",
          image: "C-logo.png",
        },
        {
          name: "Java",
          image: "java-logo.svg",
        },
        {
          name: "Python",
          image: "Python-logo.png",
        },
        {
          name: "JavaScript",
          image:
            "JavaScript-logo.png",
        },
      ],
    },
    {
      title: "Frontend",
      skills: [
        {
          name: "HTML",
          image: "html5-logo.png",
        },
        {
          name: "CSS",
          image:
            "CSS3-logo.png",
        },
        {
          name: "Bootstrap",
          image:
            "bootstrap-logo.png",
        },
        {
          name: "React",
          image:"react-logo.png",
        },
        {
          name: "Next Js",
          image:"next-js.png",
        },
        {
          name:"Tailwind CSS",
          image:"tailwind-logo.png",
        }
        // {
        //   name: "React Js",
        //   image:
        //     "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        // },
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: "Node Js",
          image: "nodejs-logo.svg",
        },
        {
          name: "Express Js",
          image:"express-logo.png",
        },
      ],
    },
    {
      title: "Others",
      skills: [
        // {
        //   name: "Git",
        //   image:
        //     "Git-logo.png",
        // },
        {
          name: "GitHub",
          image:
            "GitHub-logo.png",
        },
        {
          name: "VS Code",
          image:
            "vscode-logo.png",
        },
        {
          name: "Postman",
          image:"postman-logo.png",
        },{
          name:"MongoDB",
          image:"mongodb-logo.png",
        },
        {
          name:"Canva",
          image:"canva-logo.jpeg",
        },{
          name:"MySQL",
          image:"mysql-logo.png",
        },{
          name:"Android Studio",
          image:"androd-logo.png",
        }
      ],
    },
];
  
export const experiences = [
    {
      id: 0,
      img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
      role: "Frontend Engineer Intern",
      company: "Technoculture Research",
      date: "Jan 2024 - May 2024",
      desc: "Spearheaded implementation of app features using Native framework during the early stages of app development,   Conducted comprehensive end-to-end testing to ensure seamless functionality of critical app features. Elevated user experience by refining and enhancing existing frontend features, resulting in improved app usability.",
      skills: [
        "React Native",
        "Redux Toolkit",
        "Docker",
        "Tailwind CSS",
        "RESTful API",
        "JavaScript",
        "TypeScript",
        "Git",
      ],
    },
    {
      id: 0,
      img: "./src/images/techno.png",
      role: "SDE Intern",
      company: "Internet Innovation India Pvt. Ltd",
      date: "Oct 2023 - Jan 2024",
      desc: "Developed and executed a comprehensive marketing plan for a new telemedicine platform, targeting 500 doctors and 1000 patients.Provide Patients the ability to search and schedule appointments with doctors related to any health-related issues. Reduce bugs of code which resulted in 40% increase in new user sign-ups within the first quarter.",
      skills: [
        "React Native",
        "Redux Toolkit",
        "Tailwind CSS",
        "RESTful API",
        "React Query",
        "JavaScript",
        "TypeScript",
        "Git",
        "MongoDB"
      ],
    },
    // {
    //   id: 1,
    //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
    //   role: "Fullstack Externship",
    //   company: "Flipr",
    //   date: "June 2023 - July 2023",
    //   desc: "Built an employee management full stack web app used Docker and deployed on AWS ec2. I was the top performer in the program.",
    //   skills: [
    //     "ReactJS",
    //     "Redux",
    //     "NodeJs",
    //     "Material UI",
    //     "HTML",
    //     "CSS",
    //     "JavaScript",
    //     "Docker",
    //     "AWS",
    //     "MongoDB",
    //   ],
    // },
    // {
    //   id: 2,
    //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035",
    //   role: "Open Source Contributor ",
    //   company: "GirlScript Summer of Code",
    //   date: "May 2023 - Present",
    //   desc: "Contributing to different open-source projects and learn from industry experts",
    //   doc: "https://media.licdn.com/dms/image/D4D22AQGzSpgFaR4hsQ/feedshare-shrink_800/0/1684079632872?e=1687996800&v=beta&t=i0xWn_k32Oj9SxKfc6rARSbOghXD9Ge6WyEb2p2vvrc",
    // },
    // {
    //   id: 3,
    //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/gdsc.jpeg?alt=media&token=c162329c-efaa-4be8-a173-8d3f4c48ea70",
    //   role: "Android Developer",
    //   company: "DSC KIIT",
    //   date: "Nov2021 - Present",
    //   desc: "As an Android developer at the Google Developers Student Club (GDCS), I have had the opportunity to work on exciting projects and collaborate with talented developers who share my passion for technology. Through my involvement with GDCS, I have also had the opportunity to host and participate in numerous events, including hackathons, study jams, and workshops.",
    //   skills: [
    //     "Leadership",
    //     "Mobile Application Development",
    //     "Kotlin",
    //     "XML",
    //     "Figma",
    //   ],
    // },
    // {
    //   id: 4,
    //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Rudraksha.jpeg?alt=media&token=8f83f41e-d0a1-486f-9c7f-dd4cd1d09e8d",
    //   role: "Android Developer Intern",
    //   company: "Rudraksha Welffare Foundation",
    //   date: "June 2021 - Oct 2021",
    //   desc: "As an Android Developer Intern at Rudraksha Welfare Foundation from June 2021 to October 2021, I gained valuable hands-on experience in application development. During my tenure, I contributed to the development of the application's back-end cloud functions using Firebase and implemented a front-end with the MVVM structure, which was designed using Figma. I also added a one-to-one video call feature, conceptualized new features, and optimized app performance. This internship helped me enhance my skills in Android development and gave me an opportunity to work in a collaborative team environment.",
    //   skills: [
    //     "Android",
    //     "Java",
    //     "Kotlin",
    //     "XML",
    //     "Node Js",
    //     "Cloud Firestore",
    //     "Firebase",
    //     "Figma",
    //   ],
    //   doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245",
    // },
];
  
export const education = [
    {
      id: 0,
      img: "jss-logo.jpeg",
      school: "JSS Academy of Technical Education, Noida",
      date: "2021 - 2025",
      grade: "7.9 GPA",
      desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering(Specialization in Data Science) at JSS Academy of Technical Education, Noida with a CGPA of 7.9. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others.",
      degree: "Bachelor of Technology - BTech, Computer Science and Engineering(Data Science)",
    },
    {
      id: 1,
      img: "ved-logo.jpeg",
      school: "Ved International School",
      date: "2009-2021",
      grade: "9.4 GPA",
      desc: "I completed my Intermediate at Ved International School where I studied Maths, Physics and Chemistry stream.",
      degree: "CBSE - 12th",
    },
   
];
  
export const projects = [
  {
    "id": 9,
    "title": "GameMate",
    "description": "Developed GameMate, a real-time multiplayer matchmaking platform for online games. Implemented features like user authentication, game invites, coin staking, and solo matches. Integrated Socket.IO for real-time communication, ensuring smooth user interactions and matchmaking. The platform is designed with scalability in mind, offering a user-friendly experience.",
    "image": "gamemate.png",
    "tags": [
      "Node.js",
      "Express.js",
      "Socket.IO",
      "MongoDB",
      "Tailwind CSS",
      "React",
      "Redux",
      "Typescript",
      "MS Azure"
    ],
    "category": "Web App",
    "github": "https://github.com/abhay-01/GameMate"
  },  
    {
      id: 9,
      title: "TranscendX",
      description:
      "Utilized app for real-time AI generative images with accurate scene depiction. Developed a user-friendly interface for seamless navigation and image generation. Integrated AI models for image generation and scene depiction, resulting in a 30% increase in user engagement.",
      image:
        "transcendX.jpg",
      tags: [
        "React Native",
        "Redux Toolkit",
        "Typescript",
        "ShadCN",
        "Tailwind CSS",
        "OpenAI",
        "Gemini",
        "Cloudinary",
        "MS Azure",
        "NodeJs",
       
      ],
      category: "Mobile App",
      github: "https://github.com/abhay-01/TranscendX_App",
    },

    {
      id: 9,
      title: "Navyug",
      description:
        "Enables users to create various content types—images, videos, audio clips, conversations, and code snippets—enhancing creativity and collaboration.",
      image:
        "nav.jpg",
      tags: [
        "Next Js",
        "Typescript",
        "ShadCN",
        "Prisma",
        "Stripe",
        "OpenAI",
        "Tailwind CSS",
        "React",
      ],
      category: "web app",
      github: "https://github.com/abhay-01/next_js-saas-ai",
      webapp: "#",
    },

    {
      id: 9,
      title: "Smart Parking App",
      description:
        "• Created a user-friendly urban parking app with live updates and smooth integration with existing infrastructure, prioritiz-ing an enhanced user experience. updates and seamless infrastructure integration for an enhanced user experience.",
      image:
        "street.png",
      tags: [
        "React Native",
        "Javascript",
        "Python",
        "Firebase",
        "Tailwind CSS",
        "Google Maps",
        "Git"
      ],
      category: "Mobile App",
      github: "https://github.com/abhay-01/smart_parking_SIH",
      // webapp: "https://kjcreddy666.github.io/tictactoe",
    },

    {
      id: 9,
      title: "Realtime Web-Chat App",
      description:
        `Realtime web chat app using socket io and frontend using React and Tailwind css while backend using NodeJS and Express JS. MongoDB for DB`,
      image:
        "chat.png",
      tags: [
        "React",
        "NodeJS",
        "ExpressJS",
        "Socket.io",
        "MongoDB",
        "Tailwind CSS",
        "Git"
        
      ],
      category: "web app",
      github: "https://github.com/abhay-01/Realtime_Web_Chat",
      // webapp: "https://kjcreddy666.github.io/portfolio",
    },

    {
      id: 9,
      title: "Movies Buzz",
      description:
        "This app provides one go place to all your movies craving, from latest movies to trending movies, you got all those list here",
      image:
        "spotify-logo.png",
      tags: [
        "React Native",
        "Javascript",
        "MovieDB API",
        "Tailwind CSS",
        "Git"
      ],
      category: "Mobile app",
      github: "https://github.com/abhay-01/MovieBuzz_React-Native_App",
      // webapp: "https://kjcreddy666.github.io/spotify",
    },
    {
      id: 9,
      title: "Zegocloud Live Streaming",
      description:
        "It is a live streaming react native mobile app where you can go live and watch live streams of other users",
      image:
        "live.png",
      tags: [
        "React Native",
        "Javascript",
        "Zegocloud UI Kit",
        "Git"
      ],
      category: "Mobile App",
      github: "https://github.com/abhay-01/LiveStreaming_zegocloud",
      // webapp: "https://kjcreddy666.github.io/tictactoe",
    },

];
  
export const TimeLineData = [
    { year: 2017, text: "Started my journey" },
    { year: 2018, text: "Worked as a freelance developer" },
    { year: 2019, text: "Founded JavaScript Mastery" },
    { year: 2020, text: "Shared my projects with the world" },
    { year: 2021, text: "Started my own platform" },
];